export default __webpack_public_path__ + "static/media/svg-3.5ba2f490.svg";